module.exports = __webpack_public_path__ + "img/56188c1.jpg";